// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"492":"5500bde7","549":"1f79f495","801":"28c20c3c","823":"28c20c3c"}[chunkId] + ".chunk.css";
};